// client.js

var axios = require('axios');


var url = process.env.API_URL;

//console.log(url)

var axiosInstance = axios.create({
	baseURL: url,
    withCredentials: true
});



module.exports = axiosInstance;


// WEBPACK FOOTER //
// ./src/auth/client.js